/**
 * Created by eriksundqvist on 25/05/16.
 */
import { connect } from 'react-redux';
import { clear } from 'redux/modules/scroll-positions/index';
import SideMenu from './side-menu';

const mapDispatchToProps = (dispatch) => {
  return {
    clear: () => dispatch(clear())
  };
};

export default connect(null, mapDispatchToProps)(SideMenu);



/** WEBPACK FOOTER **
 ** ./src/components/left-page-section/side-menu/side-menu-container.js
 **/